// destinations-mock.ts — Extended destinations for TrendingGrid.
// TODO(destinations-api-PR): Replace with real GET /destinations/trending.

const IMG = (id: string, w = 1200) =>
  `https://images.unsplash.com/photo-${id}?w=${w}&q=80&auto=format&fit=crop`;

export interface Destination {
  id: string;
  city: string;
  country: string;
  code: string;
  tagline: string;
  img: string;
  price: number;
  tag: string;
  weather: string;
  vibes: string[];
}

export const TRENDING_DESTINATIONS: Destination[] = [
  {
    id: 'bali',
    city: 'Bali',
    country: 'Indonesia',
    code: 'DPS',
    tagline: 'Rice terraces & reef-break sunsets',
    img: IMG('1537996194471-e657df975ab4'),
    price: 34800,
    tag: 'TRENDING',
    weather: '29°C',
    vibes: ['Beach', 'Spiritual', 'Foodie'],
  },
  {
    id: 'tokyo',
    city: 'Tokyo',
    country: 'Japan',
    code: 'HND',
    tagline: 'Neon, ramen, vending-machine philosophy',
    img: IMG('1540959733332-eab4deabeeaf'),
    price: 57100,
    tag: 'HOT',
    weather: '18°C',
    vibes: ['City', 'Food', 'Culture'],
  },
  {
    id: 'lisbon',
    city: 'Lisbon',
    country: 'Portugal',
    code: 'LIS',
    tagline: 'Pastel facades & seven-hill skylines',
    img: IMG('1555881400-74d7acaacd8b'),
    price: 25900,
    tag: 'WEEKEND',
    weather: '22°C',
    vibes: ['City', 'Romantic', 'Beach'],
  },
  {
    id: 'reykjavik',
    city: 'Reykjavík',
    country: 'Iceland',
    code: 'KEF',
    tagline: 'Aurora, glaciers, lagoon swims',
    img: IMG('1504829857797-ddff29c27927'),
    price: 44800,
    tag: 'BUCKETLIST',
    weather: '4°C',
    vibes: ['Nature', 'Adventure'],
  },
  {
    id: 'marrakech',
    city: 'Marrakech',
    country: 'Morocco',
    code: 'RAK',
    tagline: 'Souks, riads, mint-tea afternoons',
    img: IMG('1597212618440-806262de4f6b'),
    price: 32300,
    tag: 'NEW',
    weather: '26°C',
    vibes: ['Culture', 'Foodie'],
  },
  {
    id: 'santorini',
    city: 'Santorini',
    country: 'Greece',
    code: 'JTR',
    tagline: 'Whitewash, blue domes, caldera dives',
    img: IMG('1570077188670-e3a8d69ac5ff'),
    price: 39700,
    tag: 'POPULAR',
    weather: '24°C',
    vibes: ['Beach', 'Romantic'],
  },
  {
    id: 'kyoto',
    city: 'Kyoto',
    country: 'Japan',
    code: 'UKB',
    tagline: 'Bamboo groves & temple mornings',
    img: IMG('1490806843957-31f4c9a91c65'),
    price: 56400,
    tag: 'CULTURAL',
    weather: '20°C',
    vibes: ['Culture', 'Nature', 'Spiritual'],
  },
  {
    id: 'dubai',
    city: 'Dubai',
    country: 'UAE',
    code: 'DXB',
    tagline: 'Desert sunrise to rooftop infinity pools',
    img: IMG('1512453979798-5ea266f8880c'),
    price: 21800,
    tag: 'QUICK FLY',
    weather: '34°C',
    vibes: ['City', 'Luxury', 'Beach'],
  },
  {
    id: 'phuket',
    city: 'Phuket',
    country: 'Thailand',
    code: 'HKT',
    tagline: 'Emerald bays, street food, full-moon cheer',
    img: IMG('1555400038-63f5ba517a47'),
    price: 17900,
    tag: 'VALUE',
    weather: '31°C',
    vibes: ['Beach', 'Nightlife', 'Foodie'],
  },
  {
    id: 'prague',
    city: 'Prague',
    country: 'Czech Republic',
    code: 'PRG',
    tagline: 'Gothic spires & old-town magic',
    img: IMG('1490672397548-7994edb48a72'),
    price: 41200,
    tag: 'CITY BREAK',
    weather: '16°C',
    vibes: ['City', 'Culture', 'Romantic'],
  },
];
